export default "/build/images/032-5.png?701b2f9d4efd9b844261e9cc3b8e5d47";